module.exports = __webpack_public_path__ + "img/xs_icon.1e7d443.png";